import React, { useState, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    IconLookup,
    IconDefinition,
    findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import countriesDropdownValues from "../Utils/CountriesUN";
import DropDMultiple from "./InputComponents/DropDMultiple";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import DropDTextMultiple from "./InputComponents/DropDTextMultipleComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";
import CardHeader from "./Utils/CardHeaderComponent";
import EditableTitle from "./InputComponents/EditableTitle";
import Tooltip from "./InputComponents/Tooltip";

library.add(faTrashCan);
const trashLookup: IconLookup = { prefix: "fas", iconName: "trash-can" };
const trashcanDefinition: IconDefinition = findIconDefinition(trashLookup);
library.add(faAngleRight);
const angleLookup: IconLookup = { prefix: "fas", iconName: "angle-right" };
const angleDefinition: IconDefinition = findIconDefinition(angleLookup);

interface PrimaryProducersProps {
    errors: string[];
    dropdownValues: {
        tab: string;
        inputName: string;
        listValue: string[];
    }[];
    tAndP:
    {
        table: string;
        property: string;
        tooltip: string;
        placeholder: string;
        id: string;
    }[];
    data: {
        // #### SET 1 ###
        arePrimaryProducersInvolved: string;

        beneficiaryPicList: string;

        engagedInValueChainsAtProjectLevelNotInConsortiumText: string;
        engagedInValueChainsAtProjectLevelNotInConsortiumSensitive: boolean;

        // #### SET 2 ###

        primarySectorOfActivity: string;
        primarySectorOfActivityText: string;
        primarySectorOfActivitySensitive: boolean;

        primaryActivitySpecificationText: string;
        primaryActivitySpecificationSensitive: boolean;

        // #### SET 3 ###

        projectRoles: string[];
        projectRolesText: string;
        projectRolesSensitive: boolean;
    };
    picNumbers: string[];
    handleOnChangePrimaryProducers: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleDeletePrimaryProducers: (e?: React.ChangeEvent<any>) => void;
    status: number;

    customLabelValues: {
        table: string;
        property: string;
        value: string;
        id: string;
    }[];
    handleUpdateEditableTitle: (id: string, value: string) => void;
}

function PrimaryProducer({
    data,
    handleOnChangePrimaryProducers,
    handleDeletePrimaryProducers,
    status,
    picNumbers,
    dropdownValues,
    errors,
    customLabelValues,
    handleUpdateEditableTitle,
    tAndP
}: PrimaryProducersProps) {
    const [isHidden, setIsHidden] = useState(true);
    const toggleVisibility = () => {
        setIsHidden((prevState) => !prevState);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleDeleteClick = () => {
        setIsModalOpen(true);
    };
    const confirmDelete = () => {
        setIsModalOpen(false);
        handleDeletePrimaryProducers();
    };
    const cancelDelete = () => {
        setIsModalOpen(false);
    };
    return (
        <div className="feedstock-container">
            <CardHeader
                isHidden={isHidden}
                toggleVisibility={toggleVisibility}
                cardName="Primary Producer"
                handleDelete={status == 1 ? handleDeleteClick : null}
                notValid={errors.length > 0}
            />
            <div className={isHidden ? "hidden-content" : "visible-content"}>
                <div className="form-container">
                    <div className="error-container">
                        {errors.map((error, index) => (
                            <div
                                className="error-text"
                                key={index}
                                style={{ marginBottom: "10px" }}
                            >
                                {error}
                            </div>
                        ))}
                    </div>
                    <div className="questions-wrapper">
                    <div className="question-group-input-first">
                        <div className="row">
                            <div className="col-md-12">
                                <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 1.1")?.tooltip} wide={true}>
                                    <div className="question-text">
                                        CBE JU KPI 1.1  🛈 <br />

                                        <EditableTitle
                                            customLabelValue={customLabelValues.find(item => item.property == "arePrimaryProducersInvolved")}
                                            handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                    </div>
                                </Tooltip>

                                <DropdownStringMandatory
                                    listInputs={[
                                        "-",
                                        "Yes - Beneficiary",
                                        "Yes - Engaged in value chains at project level",
                                        "No",
                                    ]}
                                    label={""}
                                    inputName={"arePrimaryProducersInvolved"}
                                    value={data.arePrimaryProducersInvolved}
                                    handleOnChange={handleOnChangePrimaryProducers}
                                    invalidValues={["-", ""]}
                                />
                            </div>
                            {data.arePrimaryProducersInvolved == "Yes - Beneficiary" ? (
                                <>
                                    <div className="col-md-6 col-sm-12"></div>

                                    <div className="col-12">
                                        <div
                                            className={
                                                data.arePrimaryProducersInvolved == "Yes - Beneficiary"
                                                    ? "visible-content"
                                                    : "hidden-content"
                                            }
                                        >
                                            <DropdownStringMandatory
                                                listInputs={picNumbers}
                                                label={"Please select the beneficiary"}
                                                inputName={"beneficiaryPicList"}
                                                value={data.beneficiaryPicList}
                                                handleOnChange={handleOnChangePrimaryProducers}
                                                invalidValues={["", "-"]}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            {data.arePrimaryProducersInvolved ==
                                "Yes - Engaged in value chains at project level" ? (
                                <>
                                    <div className="col-md-12"></div>
                                    <div className="col-md-12">
                                        <TextConfidential
                                            label={
                                                "Explain the legal/contractual link with the consortium as a whole or with a specific beneficiary. Please also explain if they are remunerated for their activities."
                                            }
                                            textValid={
                                                data
                                                    .engagedInValueChainsAtProjectLevelNotInConsortiumText
                                                    .length > 4
                                            }
                                            textValue={
                                                data.engagedInValueChainsAtProjectLevelNotInConsortiumText
                                            }
                                            textName={
                                                "engagedInValueChainsAtProjectLevelNotInConsortiumText"
                                            }
                                            onChange={handleOnChangePrimaryProducers}
                                            isConfidential={
                                                data.engagedInValueChainsAtProjectLevelNotInConsortiumSensitive
                                            }
                                            confidentialInputName={
                                                "engagedInValueChainsAtProjectLevelNotInConsortiumSensitive"
                                            }
                                            display={false}
                                        />
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>

                    <div
                        className={
                            data.arePrimaryProducersInvolved ==
                                "Yes - Engaged in value chains at project level" ||
                                data.arePrimaryProducersInvolved == "Yes - Beneficiary"
                                ? "visible-content"
                                : "hidden-content"
                        }
                    >
                        <div className="question-group-input">
                            <div className="row">
                                <div className="col-12 question-input">
                                    <div className="form-group">
                                        <div className="question-text">
                                            Sector of activity
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <DropdownStringMandatory
                                        listInputs={
                                            dropdownValues.filter(
                                                (item) => item.inputName == "primarySectorOfActivity"
                                            )[0].listValue
                                        }
                                        label={""}
                                        inputName={"primarySectorOfActivity"}
                                        value={data.primarySectorOfActivity}
                                        handleOnChange={handleOnChangePrimaryProducers}
                                        invalidValues={["", "-"]}
                                    />
                                </div>

                                {/* NEW MANDATORY TEXT FIELD FOR ACTIVITY SPECIFICATION */}
                                <div className="col-12" style={{ marginTop: "15px" }}>
                                    <TextConfidential
                                        label={"Please specify the activity/activities"}
                                        textValid={data.primaryActivitySpecificationText?.length > 4}
                                        textValue={data.primaryActivitySpecificationText || ""}
                                        textName={"primaryActivitySpecificationText"}
                                        onChange={handleOnChangePrimaryProducers}
                                        isConfidential={data.primaryActivitySpecificationSensitive || false}
                                        confidentialInputName={"primaryActivitySpecificationSensitive"}
                                        display={false}
                                    />
                                </div>

                                <div className="col-12">
                                    {data.primarySectorOfActivity == "Other" ? (
                                        <>
                                            <TextConfidential
                                                label={"Please describe"}
                                                textValid={data.primarySectorOfActivityText.length > 4}
                                                textValue={data.primarySectorOfActivityText}
                                                textName={"primarySectorOfActivityText"}
                                                onChange={handleOnChangePrimaryProducers}
                                                isConfidential={data.primarySectorOfActivitySensitive}
                                                confidentialInputName={
                                                    "primarySectorOfActivitySensitive"
                                                }
                                                display={false}
                                            />
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="question-group-input">
                            <div className="row">
                                <div className="col-12 question-input">
                                    <div className="form-group">
                                        <div className="question-text">
                                            Please select the role(s) of the primary producer in the project
                                        </div>
                                    </div>
                                </div>
                                <DropDTextMultiple
                                    listInputs={
                                        dropdownValues.filter(
                                            (item) => item.inputName == "projectRoles"
                                        )[0].listValue
                                    }
                                    label={""}
                                    inputName={"projectRoles"}
                                    value={data.projectRoles}
                                    handleOnChange={handleOnChangePrimaryProducers}
                                    isValid={data.projectRoles.length > 0}
                                />
                                <div className="col-12">
                                    {data.projectRoles.includes("Other") ? (
                                        <TextConfidential
                                            label={"Please describe"}
                                            textValid={data.projectRolesText.length > 4}
                                            textValue={data.projectRolesText}
                                            textName={"projectRolesText"}
                                            onChange={handleOnChangePrimaryProducers}
                                            isConfidential={data.projectRolesSensitive}
                                            confidentialInputName={"projectRolesSensitive"}
                                            display={false}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={cancelDelete}
                onConfirm={confirmDelete}
                title="
        Confirm deletion"
                message="Are you sure you want to delete this component ?"
            />
        </div>
    );
}

export default PrimaryProducer;